/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <rect width={23} height={23} x={0.5} y={0.5} rx={3.5} />
    <path fill="#111" d="M3 3h18v18H3z" />
    <path d="m18.525 8.775-8.25 8.25a.68.68 0 0 1-.525.225.68.68 0 0 1-.525-.225l-3.75-3.75c-.3-.3-.3-.75 0-1.05s.75-.3 1.05 0L9.75 15.45l7.725-7.725c.3-.3.75-.3 1.05 0s.3.75 0 1.05" />
    <mask
      id="check-icon_svg__a"
      width={14}
      height={11}
      x={5}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="m18.525 8.775-8.25 8.25a.68.68 0 0 1-.525.225.68.68 0 0 1-.525-.225l-3.75-3.75c-.3-.3-.3-.75 0-1.05s.75-.3 1.05 0L9.75 15.45l7.725-7.725c.3-.3.75-.3 1.05 0s.3.75 0 1.05"
      />
    </mask>
    <g mask="url(#check-icon_svg__a)">
      <path d="M3 3h18v18H3z" />
    </g>
  </svg>
)
export default SvgCheckIcon
